module.exports = __webpack_public_path__ + "img/404_320.4c031c33.png";